__turbopack_context__.v({
  "header": "index-module__agS5JW__header",
  "headerTop": "index-module__agS5JW__headerTop",
  "headerWrapper": "index-module__agS5JW__headerWrapper",
  "textHeader": "index-module__agS5JW__textHeader",
});
